import { Pipe, PipeTransform } from '@angular/core';
import { UserRoleEnum } from '@app/core/enums/user-role.enum';

@Pipe({
  name: 'userRole'
})
export class UserRolePipe implements PipeTransform {

  transform(userRole: UserRoleEnum): string {
    return {
      [UserRoleEnum.ADMIN]: $localize `Admin`,
      [UserRoleEnum.USER]: $localize `User`
    }[userRole];
  }
}
